export default "__VITE_ASSET__BiSQa8wQ__"